// John Eldhose 20190125
import { RestfulPost } from './Restful';

export async function verify(data) {
  const verify = await RestfulPost('verify', data, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return verify;
}



// WEBPACK FOOTER //
// ./src/Api/verify.js